import type { OnboardingChatMessage } from './onboarding-types';

export interface VoiceTranscriptDetail {
  role: 'user' | 'assistant';
  text: string;
  timestamp: string;
}

const COALESCE_WINDOW_MS = 1500;

/**
 * Append a Gemini Live transcript fragment to chat history, coalescing
 * same-role voice fragments that arrive within 1.5s (Live emits incrementally).
 */
export function appendVoiceTranscriptCoalesced(
  messages: OnboardingChatMessage[],
  detail: VoiceTranscriptDetail,
): OnboardingChatMessage[] {
  const trimmed = detail.text.trim();
  if (!trimmed) {
    return messages;
  }

  const last = messages[messages.length - 1];
  const now = Date.now();
  const lastTime =
    last?.voiceTimestamp != null ? new Date(last.voiceTimestamp).getTime() : 0;

  if (
    last &&
    last.source === 'voice' &&
    last.role === detail.role &&
    now - lastTime < COALESCE_WINDOW_MS
  ) {
    return messages.map((message, index) =>
      index === messages.length - 1
        ? {
            ...message,
            content: `${message.content} ${trimmed}`.trim(),
            voiceTimestamp: detail.timestamp,
          }
        : message,
    );
  }

  return [
    ...messages,
    {
      role: detail.role,
      content: trimmed,
      source: 'voice',
      voiceTimestamp: detail.timestamp,
    },
  ];
}
